import { LitElement, html } from "lit-element";
import { SharedStyles } from "../../../../styles/shared-styles";
import { addMetadata } from "../../ModuleBase/ModuleMetadata";

export class SelectorModule extends LitElement {
	Activate() {
		this.canvas.defaultCursor = "crosshair";
		this.__checkIfActive = () => this.checkIfActive();
		this.canvas.on('selection:created', this.__checkIfActive);
		this.canvas.on('selection:cleared', this.__checkIfActive);
		this.__checkIfActive();
		return this;
	}

	Deactivate() {
		this.canvas.defaultCursor = "default";
		this.canvas.off("selection:created", this.__checkIfActive);
		this.canvas.off("selection:cleared", this.__checkIfActive);
	}

	render() {
		return html`
            ${SharedStyles}
            <style>
                :host {
                   width: 100%;
                }

                .direction {
                    width: 100%;
                    display: flex;
                    flex-direction: column;
                    margin-top: 5px;
                    justify-content: start;
                }
            
                .direction label {
                    display: block;
                    height: 40px;
                    cursor: pointer;
                    text-align: center;
                    font-size: 12px;
                    width: 100%;
                    padding: 5px;
                }

                label[disabled] {
                    stroke: #93939f;
                    fill: #93939f;
                    cursor: not-allowed;
                }
            </style>
            <div class="direction">
                <label ?disabled=${this.isNotActive} @click="${e => this._handleChangeEvent(e)}">${this.icon}</label>
            </div>
        `;
	}

	_handleChangeEvent(e) {
		const activeObj = this.canvas.getActiveObject();
		if (activeObj == undefined || this.isNotActive) return;

		switch (this.direction) {
			case "bringToFront":
				this.canvas.bringToFront(activeObj);
				this.canvas.trigger("object:modified", { target: activeObj })
				break;
			case "bringForward":
				this.canvas.bringForward(activeObj);
				this.canvas.trigger("object:modified", { target: activeObj })
				break;
			case "sendBackwords":
				this.canvas.sendBackwards(activeObj);
				this.canvas.trigger("object:modified", { target: activeObj })
				break;
			case "sendToBack":
				this.canvas.sendToBack(activeObj);
				this.canvas.trigger("object:modified", { target: activeObj })
				break;
			case "fliph":
				activeObj.set('flipY', !activeObj.flipY);
				this.canvas.trigger("object:modified", { target: activeObj })
				break;
			case "flipv":
				activeObj.set('flipX', !activeObj.flipX);
				this.canvas.trigger("object:modified", { target: activeObj })
				break;
			case "rotatel":
				this.rotateLeft(activeObj);
				activeObj.setCoords();
				this.canvas.trigger("object:modified", { target: activeObj })
				break;
			case "rotater":
				this.rotateRight(activeObj)
				activeObj.setCoords();
				this.canvas.trigger("object:modified", { target: activeObj })
				break;
			case "copy":
				this.makeCopy(activeObj);
				break;
		}
		this.canvas.renderAll();
	}

	makeCopy(activeObj) {
		let copiedObj;
		if (activeObj.forEachObject) {
			let newObj = [];
			activeObj.forEachObject((obj) => newObj.push(fabric.util.object.clone(obj)));
			copiedObj = new fabric.Group(newObj);
			copiedObj.width = activeObj.width;
			copiedObj.height = activeObj.height;
			copiedObj.left = activeObj.left;
			copiedObj.top = activeObj.top;
			copiedObj.angle = activeObj.angle;
			copiedObj.scaleX = activeObj.scaleX;
			copiedObj.scaleY = activeObj.scaleY;
		} else {
			copiedObj = activeObj.toJSON();
			let objArr = [];
			fabric.util.enlivenObjects([copiedObj], function (objects) {
				objects.forEach(function (o) {
					objArr.push(o);
				});
			});
			copiedObj = objArr[0];
		}
		copiedObj.set("top", copiedObj.top + 25);
		copiedObj.set("left", copiedObj.left + 25);
		if (activeObj.moduleName && activeObj.moduleState) {
			copiedObj.moduleName = activeObj.moduleName;
			addMetadata(copiedObj, activeObj.moduleState)
		}
		this.canvas.add(copiedObj);
	}

	rotateLeft(activeObj) {
		if (!activeObj.angle % 90)
			activeObj.rotate(activeObj.angle - 90 + 360);
		else if (activeObj.angle > 270)
			activeObj.rotate(270);
		else if (activeObj.angle > 180)
			activeObj.rotate(180);
		else if (activeObj.angle > 90)
			activeObj.rotate(90);
		else
			activeObj.rotate(0);
	}

	rotateRight(activeObj) {
		if (!activeObj.angle % 90)
			activeObj.rotate(activeObj.angle + 90);
		else if (activeObj.angle < 90)
			activeObj.rotate(90);
		else if (activeObj.angle < 180)
			activeObj.rotate(180);
		else if (activeObj.angle < 270)
			activeObj.rotate(270);
		else
			activeObj.rotate(0);
	}

	checkIfActive() {
		const selectedCount = this.canvas.getActiveObjects().length;
		switch (this.direction) {
			case 'copy':
				this.isNotActive = selectedCount !== 1;
				break;
			default:
				this.isNotActive = selectedCount < 1;
		}
	}

	static get properties() {
		return {
			direction: { type: String },
			isNotActive: { type: Boolean },
		};
	}

	constructor(canvas, direction, icon) {
		super();
		this.canvas = canvas;
		this.icon = icon;
		this.direction = direction;
		this.isNotActive = false;
	}
}

window.customElements.define("inspx-draw-selector-module", SelectorModule);
